import { Component, OnInit, ViewChild,  OnDestroy, AfterViewInit } from '@angular/core';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { first, skipWhile, Subscription, take } from 'rxjs';
import { InventoryDialogComponent } from '../inventory-dialog/inventory-dialog.component';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { selectCountsCurrentInventoryState, selectCountsState } from '../store/selectors/counts.selectors';
import * as CountsActions from '../store/actions/counts.actions'
import { quickSort } from '@app/shared/helpers/quickSort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SendMailModalComponent } from '@app/shared/components/send-mail-modal/send-mail-modal.component';

@Component({
  selector: 'app-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.scss']
})
export class FinancialComponent implements OnInit, OnDestroy {
  public inventory:any;
  public inventoryItems: [] = [];
  public dataSource:any;
  public endTimeStamp: string;
  public $tmpTotal = 0.00;
  public $tmpRetailTotal = 0.00;
  public $tmpProfitTotal = 0.00;
  public hasAsteriskProducts = false;
  public $tmpCalcTotal;
  public sortedData = []
  public columns = [
    { columnDef: 'prdCode', header: 'Product Code'},
    { columnDef: 'prdNameEn', header: 'Description'},
    { columnDef: 'prdCasePack', header: 'UOM'},
    { columnDef: 'invitmCount', header: 'Count'},
    // { columnDef: 'pcmDesc', header: 'Count Type'},
    { columnDef: 'pcmCost', header: 'Cost per unit'},
    { columnDef: 'pcmRetail', header: 'Retail Price'},
    { columnDef: 'totalCost', header: 'Total Cost'},
    { columnDef: 'totalRetail', header: 'Total Retail'},
    { columnDef: 'totalProfit' , header: 'Total Avail. Profit'}
  ];
  private inventorySubscription = new Subscription;
  public displayedColumns = this.columns.map(c => c.columnDef);
  public isFinalizedScreen = this._inventory.isFinalizeScreen();
  public isLoading: boolean = false;
  private subs = new SubSink;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private _inventory: InventoryService,
    private _dialogRef: MatDialogRef<InventoryDialogComponent>,
    private _router: Router,
    private store$: Store,
    private _matDialog: MatDialog,
    private _liveAnnouncer: LiveAnnouncer
    ) {
      let id;
      this.subs.add(this.store$.select(selectCountsState).subscribe(res => id = res.currentId));
      this.store$.dispatch(CountsActions.loadFinancial({ invID: id, active: "prdNameEn", direction: "asc" }));
     }

     ngOnInit(): void {
      this.subs.add(this.store$.select(selectCountsState).pipe(skipWhile(({ currentInventory })=> currentInventory == null)).subscribe(({ currentInventory, isLoading })=> {

        const mergedInventory = {};
        
        currentInventory.invItems.forEach((item: any) => {
          const prdID = item.prdID;

          if (!mergedInventory[prdID]) {
            mergedInventory[prdID] = { ...item };
            mergedInventory[prdID].invitmCount = parseFloat(item.invitmCount);
            mergedInventory[prdID].totalCost = parseFloat(item.totalCost);
            mergedInventory[prdID].totalRetail = parseFloat(item.totalRetail);
            mergedInventory[prdID].totalProfit = parseFloat(item.totalProfit);
            mergedInventory[prdID].isCombined = false;
          } else {
            mergedInventory[prdID].invitmCount += parseFloat(item.invitmCount);
            mergedInventory[prdID].totalCost += parseFloat(item.totalCost);
            mergedInventory[prdID].totalRetail += parseFloat(item.totalRetail);
            mergedInventory[prdID].totalProfit += parseFloat(item.totalProfit);
            mergedInventory[prdID].isCombined = true;
            this.hasAsteriskProducts = true;
          }
        });

        currentInventory.invItems = Object.values(mergedInventory);

        this.inventory = currentInventory.inv;
        this.dataSource = new MatTableDataSource(currentInventory.invItems);
        this.sortedData = currentInventory.invItems;
        this.endTimeStamp = this.inventory?.endTimeStamp;
        this.inventoryItems = currentInventory?.invItems;
        this.isLoading = isLoading
      }));
    }

  ngOnDestroy(){
    this.subs.unsubscribe()
  }

  generatePDF() {
   this._inventory.generateValuePDF(this.inventory.invID, this.sort.active ? this.sort.active : 'prdNameEn', this.sort.direction ? this.sort.direction : 'asc', this.isFinalizedScreen ? 1 : 0);
  }

  public onSortData(sort: Sort) {
    this.store$.dispatch(CountsActions.loadFinancial({ invID: this.inventory.invID, active: sort.active, direction: sort.direction }))
  }

  public compare(a: number | string, b: number |  string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  public onCheck(val){
    if(val <= 0){
      return 'N/A';
    }
    return `$`  + val;
  }

  public onCheckIfZero(v){
    if(v <= 0){
      return 'N/A';
    }
    return `$${v}`;
  }

  sendReport() {
    const dialog = this._matDialog.open(SendMailModalComponent, {
      minWidth: '30vw',
      maxWidth: '700px',
    });

    dialog.afterClosed().pipe(first()).subscribe(res => {
       if(res!=null && res.email!=null && res.email!=''){
          const data = {
            email: res.email,
            id: this.inventory.invID,
            active: this.sort.active ? this.sort.active : 'prdNameEn',
            direction: this.sort.direction ? this.sort.direction : 'asc',
            finalized: this.isFinalizedScreen ? 1 : 0,
            type: 'byValue'
          }

          this._inventory.onSendReportPDF(data);
        }
    });
  }
  
}

